export const APP_URL = 'https://plattform.fondsconsult.de/';

export const API_URL = APP_URL + 'api/';

export const CONTACT_US_URL = `${API_URL}contact/website/`;
